import { render, staticRenderFns } from "./inspectionAdmin.vue?vue&type=template&id=6742758a&"
import script from "./inspectionAdmin.vue?vue&type=script&lang=ts&"
export * from "./inspectionAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionAdmin.vue?vue&type=style&index=0&lang=postcss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports